import {useEffect, useState} from "react";
import Spinner from "../../components/spinner/Spinner";
import SportelliService from "../../services/SportelliService";
import oggettiUtili from "../../utils/OggettiUtili.json"
import Autocomplete from "../../components/Autocomplete/Autocomplete";
import Input from "../../components/inputText/Input";
import L from "leaflet";
import icon from "./constants";


function DoveSiamo(props) {

    const [showSpinner, setShowSpinner] = useState(false)
    const [sportelliTotali, setSportelliTotali] = useState(null)
    const [state, setState] = useState({comune: "", cap: ""})
    const [filtro,setFiltro] = useState("")
    const [flagFiltro, setFlagFiltro] = useState(false)
    const [flagNessunRisultato, setFlagNessunRisultato] = useState(false)
    const [rerenderAutocomplete, setRerenderAutoComplete] = useState(0)
    const [map, setMap] = useState({})
    const [posizioneRicerca, setPosizioneRicerca] = useState([45.6662855, 12.242072])

    const comuni = JSON.parse(sessionStorage.getItem("comuniCoordinate"))

    useEffect(() => {
        let mappa = L.map('map').setView(posizioneRicerca, 8);
        mappa.options.minZoom = 8;
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(mappa);
        setMap(mappa)
    }, [])

    useEffect( ()=> {
        getAllSportelli(true)
    },[map,setMap])

    function onChange(id, value) {
        let newState = {...state}
        newState[id] = value
        setState(newState)
    }

    function onClickRicerca() {
        if(state.comune){
            setFiltro(state.comune.descrizione)
            let arrayPosition = [state.comune.latitudine, state.comune.longitudine]
            setPosizioneRicerca(arrayPosition)
        }else if(state.cap){
            setFiltro(state.cap)
        }
        getAllSportelli()
    }

    function getAllSportelli(flagPrimaChiamata,flagAnnullaFiltro) {

        setShowSpinner(true)

        let params = {paginazione: false}
        if(!flagAnnullaFiltro){
            if (state.comune && state.comune.descrizione) {
                params.comune = state.comune.descrizione
            } else if (state.cap) {
                params.cap = state.cap
            }
        }
        SportelliService.getSportelli(params).then(res => {

            if (flagPrimaChiamata) {
                setSportelliTotali(res.data)
            }
            if (!res.data || res.data.length === 0) {
                setFlagNessunRisultato(true)
                setFlagFiltro(false)
            } else {
                setFlagNessunRisultato(false)
            }
            if((params.comune || params.cap) && res.data && res.data.length > 0){
                setFlagFiltro(true)
            }
            if(map){
                initMap(res.data && res.data.length > 0 ? res.data : sportelliTotali, flagAnnullaFiltro)
            }

            setShowSpinner(false)

        }).catch(reason => {
            console.log("Errore Operation GET Sportelli: " + reason)
            setShowSpinner(false)
        })
    }

    function onClickAnnullaFiltro(){
        let newState = {comune: "",cap:""}
        setState(newState)
        setRerenderAutoComplete(rerenderAutocomplete + 1)
        setFlagFiltro(false)
        getAllSportelli(false,true)
        map.setView(posizioneRicerca, 7);
    }

    function initMap(sportelli, flagAnnullaFiltro) {
        let positionMarkerArray = []

        if (sportelli && sportelli.length > 0) {

                let orariSportelloPerCodice = oggettiUtili.orariPerCodice
                map.eachLayer(function (layer) {
                    map.removeLayer(layer)
                });
                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }).addTo(map);

                sportelli.map((sportello) => {
                    let orariSportello = {
                        lunediMattina: sportello.orari.lunediMattina1 && sportello.orari.lunediMattina2 ? orariSportelloPerCodice[sportello.orari.lunediMattina1] + " - " + orariSportelloPerCodice[sportello.orari.lunediMattina2] : "CHIUSO",
                        lunediPomeriggio: sportello.orari.lunediPomeriggio1 && sportello.orari.lunediPomeriggio2 ? orariSportelloPerCodice[sportello.orari.lunediPomeriggio1] + " - " + orariSportelloPerCodice[sportello.orari.lunediPomeriggio2] : "CHIUSO",
                        martediMattina: sportello.orari.martediMattina1 && sportello.orari.martediMattin2 ? orariSportelloPerCodice[sportello.orari.martediMattina1] + " - " + orariSportelloPerCodice[sportello.orari.martediMattina2] : "CHIUSO",
                        martediPomeriggio: sportello.orari.martediPomeriggio1 && sportello.orari.martediPomeriggio2 ? orariSportelloPerCodice[sportello.orari.martediPomeriggio1] + " - " + orariSportelloPerCodice[sportello.orari.martediPomeriggio2] : "CHIUSO",
                        mercolediMattina: sportello.orari.mercolediMattina1 && sportello.orari.mercolediMattina2 ? orariSportelloPerCodice[sportello.orari.mercolediMattina1] + " - " + orariSportelloPerCodice[sportello.orari.mercolediMattina2] : "CHIUSO",
                        mercolediPomeriggio: sportello.orari.mercolediPomeriggio1 && sportello.orari.mercolediPomeriggio2 ? orariSportelloPerCodice[sportello.orari.mercolediPomeriggio1] + " - " + orariSportelloPerCodice[sportello.orari.mercolediPomeriggio2] : "CHIUSO",
                        giovediMattina: sportello.orari.giovediMattina1 && sportello.orari.giovediMattina2 ? orariSportelloPerCodice[sportello.orari.giovediMattina1] + " - " + orariSportelloPerCodice[sportello.orari.giovediMattina2] : "CHIUSO",
                        giovediPomeriggio: sportello.orari.giovediPomeriggio1 && sportello.orari.giovediPomeriggio2 ? orariSportelloPerCodice[sportello.orari.giovediPomeriggio1] + " - " + orariSportelloPerCodice[sportello.orari.giovediPomeriggio2] : "CHIUSO",
                        venerdiMattina: sportello.orari.venerdiMattina1 && sportello.orari.venerdiMattina2 ? orariSportelloPerCodice[sportello.orari.venerdiMattina1] + " - " + orariSportelloPerCodice[sportello.orari.venerdiMattina2] : "CHIUSO",
                        venerdiPomeriggio: sportello.orari.venerdiPomeriggio1 && sportello.orari.venerdiPomeriggio2 ? orariSportelloPerCodice[sportello.orari.venerdiPomeriggio1] + " - " + orariSportelloPerCodice[sportello.orari.venerdiPomeriggio2] : "CHIUSO",
                        sabatoMattina: sportello.orari.sabatoMattina1 && sportello.orari.sabatoMattina2 ? orariSportelloPerCodice[sportello.orari.sabatoMattina1] + " - " + orariSportelloPerCodice[sportello.orari.sabatoMattina2] : "CHIUSO",
                        sabatoPomeriggio: sportello.orari.sabatoPomeriggio1 && sportello.orari.sabatoPomeriggio2 ? orariSportelloPerCodice[sportello.orari.sabatoPomeriggio1] + " - " + orariSportelloPerCodice[sportello.orari.sabatoPomeriggio2] : "CHIUSO"
                    }

                    let contentStringOrariSportello =
                        '<div class="row">' +
                        '<div class="col-1">' +
                        '<svg class = "iconInfoWindow" viewBox="0 0 24 24" id="it-clock" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M11.5 5h1v7.5H7v-1h4.5zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"/>' +
                        '<path fill="none" d="M0 0h24v24H0z"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="col-10">' +
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<span class="spanInfoWindow">Lunedi</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        '<span class="spanInfoWindow">' + orariSportello.lunediMattina + '</span>' +
                        '</div>' +
                        '<div class="col-5">' +
                        '<span class="spanInfoWindow">' + orariSportello.lunediPomeriggio + '</span>' +
                        '</div>' +
                        ' </div>' +
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<span class="spanInfoWindow">Martedì</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        '<span class="spanInfoWindow">' + orariSportello.martediMattina + '</span>' +
                        '</div>' +
                        '<div class="col-5">' +
                        '<span class="spanInfoWindow">' + orariSportello.martediPomeriggio + '</span>' +
                        '</div>' +
                        '</div>' +
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<span class="spanInfoWindow">Mercoledì</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        '<span class="spanInfoWindow">' + orariSportello.mercolediMattina + '</span>' +
                        '</div>' +
                        '<div class="col-5">' +
                        '<span class="spanInfoWindow">' + orariSportello.mercolediPomeriggio + '</span>' +
                        '</div>' +
                        ' </div>' +
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<span class="spanInfoWindow">Giovedì</span>' +
                        '</div>' +
                        ' <div class="col-4">' +
                        '<span class="spanInfoWindow">' + orariSportello.giovediMattina + '</span>' +
                        '</div>' +
                        '<div class="col-5">' +
                        '<span class="spanInfoWindow">' + orariSportello.giovediPomeriggio + '</span>' +
                        '</div>' +
                        '</div>' +
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<span class="spanInfoWindow">Venerdì</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        '<span class="spanInfoWindow">' + orariSportello.venerdiMattina + '</span>' +
                        '</div>' +
                        '<div class="col-5">' +
                        '<span class="spanInfoWindow">' + orariSportello.venerdiPomeriggio + '</span>' +
                        '</div>' +
                        '</div>' +
                        '<div class="row">' +
                        '<div class="col-3">' +
                        '<span class="spanInfoWindow">Sabato</span>' +
                        '</div>' +
                        '<div class="col-4">' +
                        '<span class="spanInfoWindow">' + orariSportello.sabatoMattina + '</span>' +
                        '</div>' +
                        '<div class="col-5">' +
                        '<span class="spanInfoWindow">' + orariSportello.sabatoPomeriggio + '</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>'

                    let contentStringAppuntamento =
                        '<div class="row">' +
                        '<div class="col-1">' +
                        '<svg class = "iconInfoWindow" viewBox="0 0 24 24" id="it-clock" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M11.5 5h1v7.5H7v-1h4.5zM22 12A10 10 0 1112 2a10 10 0 0110 10zm-1 0a9 9 0 10-9 9 9 9 0 009-9z"/>' +
                        '<path fill="none" d="M0 0h24v24H0z"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="col-10">' +
                        '<div class="row">' +
                        '<div class="col-10">' +
                        '<span class="spanInfoWindow">Orari:</span>' +
                        '</div>' +
                        '</div>' +
                        '<div class="row">' +
                        '<div class="col-10">' +
                        '<span class="spanInfoWindow">Ricevimento solo su appuntamento</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>'

                    let contentStringNote =
                        '<div class="row">' +
                        '<div class="col-1">' +
                        '<svg class = "iconInfoWindow" viewBox="0 0 24 24" id="it-note" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M18.5 4h-13A1.5 1.5 0 004 5.5v13A1.5 1.5 0 005.5 20h10.2l4.3-4.3V5.5A1.5 1.5 0 0018.5 4zM5 18.5v-13a.5.5 0 01.5-.5h13a.5.5 0 01.5.5V15h-2.5a1.5 1.5 0 00-1.5 1.5V19H5.5a.5.5 0 01-.5-.5zM18.3 16L16 18.3v-1.8a.5.5 0 01.5-.5zM16 9H8V8h8zm0 2H8v-1h8zm-2 1v1H8v-1z"/>' +
                        '<path fill="none" d="M0 0h24v24H0z"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="col-10">' +
                        '<div class="row">' +
                        '<div class="col-10">' +
                        '<span class="spanInfoWindow">Note:</span>' +
                        '</div>' +
                        '</div>' +
                        '<div class="row">' +
                        '<div class="col-10">' +
                        '<span class="spanInfoWindow" style="overflow-wrap: anywhere">' + sportello.note + '</span>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>'

                    let contentStringSportello = ""
                    if (sportello.appuntamento && sportello.appuntamento === true) {
                        contentStringSportello = contentStringSportello + contentStringAppuntamento;
                    }
                    if (sportello.note && sportello.note !== "") {
                        contentStringSportello = contentStringSportello + contentStringNote;
                    }
                    if (sportello.orari) {
                        contentStringSportello = contentStringSportello + contentStringOrariSportello;
                    }

                    let contentString =
                        '<div class="infoWindowContainer">' +
                        '<span class="titleInfoWindow">Sportello ' + sportello.comune.descrizione + '</span>' +
                        '<br/>' +
                        '<span class="spanInfoWindow">' + sportello.indirizzo + '</span>' +
                        '<br/>' +
                        '<div class="row rowInfoWindow">' +
                        '<div class="col-1">' +
                        '<svg class = "iconInfoWindow" viewBox="0 0 24 24" id="it-telephone" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M5 3h.18M20 11.56A7.59 7.59 0 0012.48 4h-.06a.49.49 0 00-.49.48.5.5 0 00.49.51A6.61 6.61 0 0119 11.62a.51.51 0 00.54.46.49.49 0 00.45-.46s.01-.04.01-.06z"/>' +
                        '<path d="M16.93 11.68a4.5 4.5 0 00-4.48-4.48.51.51 0 000 1 3.5 3.5 0 013.49 3.49.5.5 0 00.5.5.51.51 0 00.5-.51zM15.68 21.19a13.32 13.32 0 01-12.8-13.1.92.92 0 01.62-.88c1.74-.56 4-1 4.7.06a7.39 7.39 0 01.85 2.91v.21a1.48 1.48 0 01-.7 1.68.81.81 0 00-.49.71 12.55 12.55 0 003.38 3.51.88.88 0 00.48-.56c.09-.53.58-1 1.7-.85h.21a7 7 0 012.85.87c1 .72.62 3 .09 4.72a1 1 0 01-.89.72zM6.55 7.52a9.5 9.5 0 00-2.78.55 12.41 12.41 0 0011.91 12.22c.73-2.26.66-3.54.31-3.78a6.66 6.66 0 00-2.46-.72h-.22c-.32 0-.65 0-.68.12a1.9 1.9 0 01-1.27 1.34l-.21.07-.15-.15a13.44 13.44 0 01-3.9-4L7 13a1.68 1.68 0 011-1.7c.12-.07.33-.18.25-.75v-.22a6.84 6.84 0 00-.7-2.54c-.2-.18-.55-.27-1-.27z"/>' +
                        '</svg>' +
                        '</div>' +
                        '<div class="col-10">' +
                        '<span class="spanInfoWindow">' + sportello.telefono + '</span>' +
                        '</div>' +
                        ' </div>' +
                        '<div class="row rowInfoWindow">' +
                        '<div class="col-1">' +
                        '<svg class = "iconInfoWindow" viewBox="0 0 24 24" id="it-mail" xmlns="http://www.w3.org/2000/svg">' +
                        '<path d="M20.5 5h-17A1.5 1.5 0 002 6.5v11A1.5 1.5 0 003.5 19h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 5zm-.3 1l-7.1 7.2a1.6 1.6 0 01-2.2 0L3.8 6zM3 17.3V6.6L8.3 12zm.7.7L9 12.7l1.2 1.2a2.7 2.7 0 003.6 0l1.2-1.2 5.3 5.3zm12-6L21 6.6v10.7z"/>' +
                        '<path fill="none" d="M0 0h24v24H0z"/>' +
                        ' </svg>' +
                        '</div>' +
                        '<div class="col-10">' +
                        '<span class="spanMailInfoWindow">' + sportello.email + '</span>' +
                        ' </div>' +
                        '</div>' +
                        contentStringSportello +
                        '</div>';

                    let markera = L.marker([sportello.latitudine, sportello.longitudine], {icon}).bindPopup(contentString, {maxWidth: 370})
                    map.addLayer(markera);
                    positionMarkerArray.push([sportello.latitudine, sportello.longitudine])
                })

            if(positionMarkerArray.length == 1){
                map.setView(positionMarkerArray[0], 13);
            }else if(state.comune && state.comune.latitudine && state.comune.longitudine && !flagAnnullaFiltro){
                // set posizione della mappa triangolarizzando le posizioni dei marker
                map.fitBounds(positionMarkerArray);
            }
        }
    }

    return (
        <div style={{margin: "1rem"}}>
            <Spinner show={showSpinner}/>
            <span style={{fontWeight: "bold", fontSize: "28px"}}>Trova lo sportello più vicino</span>
            <br/>
            <span style={{fontSize: "18px"}}>La domanda di iscrizione al Registro può essere presentata direttamente dall'interessato presso i seguenti Sportelli:</span>
            <div className={"row"} style={{marginTop: "1rem"}}>
                <div className={"col-3"}>
                    <Autocomplete
                        id={"comune"}
                        value={state.comune}
                        rerender={rerenderAutocomplete}
                        placeholder={"Ricerca per città"}
                        suggestions={comuni}
                        disabled={state.cap || !map}
                        onChange={onChange}/>
                </div>
                <div className={"col-3"}>
                    <Input
                        id={"cap"} value={state.cap}
                        disabled={state.comune || !map }
                        placeholder={"Ricerca per codice postale"}
                        onChange={(event) => onChange(event.target.id, event.target.value)}/>
                </div>
                <div className={"col-1"} style={{
                    opacity: (state.cap || state.comune && state.comune.descrizione ) ? "1" : "0.5",
                    cursor: (state.cap || state.comune && state.comune.descrizione) ? "pointer" : "not-allowed"
                }}>
                    <svg width={"50"} height={"50"} viewBox="0 0 24 24" fill={"#1b7ea9"} id="it-search"
                         xmlns="http://www.w3.org/2000/svg"
                         onClick={(state.cap || state.comune && state.comune.descrizione) ? onClickRicerca : null}>
                        <path
                            d="M21.9 21.1L16 15.3a8.3 8.3 0 002-5.3 8 8 0 10-8 8 8.3 8.3 0 005.3-2l5.8 5.9zM10 17a7 7 0 117-7 7 7 0 01-7 7z"/>
                        <path fill="none" d="M0 0h24v24H0z"/>
                    </svg>
                </div>
                {flagFiltro ?
                    <div className={"col-1"} style={{border:"2px solid #1b7ea9",height:"fit-content",marginTop:"5px",minWidth:"fit-content"}}>
                        <svg style={{float:"right",top:"0",cursor:"pointer"}} fill={"red"} width={24} height={24} viewBox="0 0 24 24" id="it-close"
                             xmlns="http://www.w3.org/2000/svg" onClick={onClickAnnullaFiltro}>
                            <path d="M12.7 12l3.7 3.6-.8.8-3.6-3.7-3.6 3.7-.8-.8 3.7-3.6-3.7-3.6.8-.8 3.6 3.7 3.6-3.7.8.8z"/>
                            <path fill="none" d="M0 0h24v24H0z"/>
                        </svg>
                        <span>{filtro}</span>
                    </div> : <></>}
            </div>
            {flagNessunRisultato ? <div>
                <span style={{fontSize: "18px"}}>Nessuno Sportello trovato per il Comune/CAP inserito</span>
            </div> : <></>}

            <div id="map"></div>
        </div>

    )

}

export default DoveSiamo;

